export default __webpack_public_path__ + "static/media/reactjs.e71f4c5b.png";